import { CancelToken } from "axios";
import { actionChannel, take, fork, call, put } from "redux-saga/effects";
import getAxios from "./axiosAPI";
import history from '../history/history';
//import { toast } from 'react-toastify';
import * as utils from '../../Utils';
import _ from "lodash";
import { isWhitelabel } from "../../Utils/token";
import { homeRedirectTenantWise } from "../../Utils/ServiceProviders";

const pendingRequests = {};

const apiCache = {};

const CACHE_DURATION_PARENT = 60 * 1000; // 1 minute

const CACHE_DURATION_SENIOR = 60 * 100000; // 100 minute

const getCachedResponse = (url) => {
  const curLocation = window.location.href;
  if (curLocation.indexOf('parent/senior') !== -1) {
    const cached = apiCache[url];
    if (cached && (Date.now() - cached.timestamp < CACHE_DURATION_SENIOR)) {
      return cached.response;
    }
  } else {
    const cached = apiCache[url];
    if (cached && (Date.now() - cached.timestamp < CACHE_DURATION_PARENT)) {
      return cached.response;
    }
  }


  return null;
};

const setCachedResponse = (url, response) => {
  //console.log("Caching response for URL:", apiCache);
  apiCache[url] = {
    response,
    timestamp: Date.now()
  };
};

const clearApiCache = (url) => {
  console.log("Clearing cache for URL:", url);
  if (url.indexOf('signalr') !== -1) { return }
  Object.keys(apiCache).forEach(key => delete apiCache[key]);
};


const similarPendingRequestExist = (actionType, url) =>
  pendingRequests[actionType] && pendingRequests[actionType].url === url;

function* invokeAPI(action) {
  const { payload } = action;
  const currentHref = window.location.href;
  //console.log(currentHref,action);
  const {
    method,
    url,
    data,
    apiConfig,
    action: actionType,
    resolve,
    reject,
    isLoader,
  } = payload;

  let isWhitelabeled = isWhitelabel();

  try {

    let response = {};

    if (isLoader) {
      utils.showLoader();
    }
    const api = getAxios();
    switch (method) {
      case "GET": {
        //if (similarPendingRequestExist(actionType, url)) {
        //throw new Error("Similar axios request detected!");
        //} else {

        const cached = getCachedResponse(url);
        if (cached) {
          // ✅ Return cached response
          response = cached;
          //console.log(response);
        } else {
          const source = CancelToken.source();
          const cancelToken = source.token;
          pendingRequests[actionType] = { url, api, source };

          response = yield call([api, api.get], url, {
            ...apiConfig,
            cancelToken,
          });
          setCachedResponse(url, response);
        }


        //}


        break;
      }
      case "POST":
        clearApiCache(url);
        response = yield call([api, api.post], url, data, { ...apiConfig });
        break;

      case "PUT":
        clearApiCache(url);
        response = yield call([api, api.put], url, data, { ...apiConfig });
        break;

      case "PATCH":
        clearApiCache(url);
        response = yield call([api, api.patch], url, data, { ...apiConfig });
        break;

      case "DELETE":
        clearApiCache(url);
        response = yield call([api, api.delete], url, { ...apiConfig });
        break;

      case "EMPTY":
        response = { status: 200, data: { status: 200 } }
        break;

      default:
        throw new Error(`API method ${method} is not supported!`);
    }

    if (response.config.url.includes('stage-')) {
      sessionStorage.setItem('env', 'stage')
    } else if (response.config.url.includes('uat-')) {
      sessionStorage.setItem('env', 'uat')
    } else {
      sessionStorage.setItem('env', 'prod')
    }

    if (response.status === Number(200)
      || response.status === Number(201)
      || response.status === Number(201)
    ) {
      // console.log(response);
      // if(!response.data.data){
      //   response.data = {...response.data,data:[]}
      // }
      yield* dispatchFulfilled(action, response.data);

      // yield put(showToastMessage({ message: _get(response, 'data.message', ''), type: _get(response, 'data.type', '') }));
    } else if (response.status === Number(401) && !isWhitelabeled) {
      //console.log(response.status)
      clearApiCache(url);
      if ((new URL(window.location.href)).pathname.indexOf("login") === -1) {
        sessionStorage.clear();
        //toast.error(`Session Timed out! Please login again`);
        yield call(forwardTo, '/');
      }

      yield* dispatchRejected(payload.action, action, "Internal server error");
      // yield put(showToastMessage({ message: _get(response, 'data.message', ''), type: _get(response, 'data.type', '') }));
    } else if (response.status === Number(502)) {
      clearApiCache(url);
      localStorage.setItem("redirectTo", currentHref);
      setTimeout(() => {
        window.location.href = '/internal-server-error';
      }, 500)
      yield* dispatchRejected(payload.action, action, "Internal server error");
    } else {
      // localStorage.setItem("redirectTo",currentHref);
      // yield call(forwardTo, '/internal-server-error');
      yield* dispatchRejected(payload.action, action, "Internal server error");
      //yield put(showToastMessage({ message: 'Session Timed out! Please login again' }));
    }
    delete pendingRequests[actionType];

    if (_.isEmpty(pendingRequests)) {
      utils.hideLoader();
    }
    if (resolve) {
      //response = {...response,apiStatusCode:response.status}
      const status = (response && response.status) ? response.status : 200;
      resolve(response.data, status);
    }
  } catch (error) {//console.log(error);
    //clearApiCache(url);
    delete pendingRequests[actionType];
    if (_.isEmpty(pendingRequests)) {
      utils.hideLoader();
    }

    // if (error && error.message === "Network Error") {

    //   if ((new URL(window.location.href)).pathname.indexOf("login") === -1) {
    //     // yield put({ type: `LOGOUT`, payload: error.response });
    //     sessionStorage.clear();
    //     window.location.href = "/";
    //   }
    //   // return;
    // }
    if (error.response && error.response.status === 401 && !isWhitelabeled) {

      if ((new URL(window.location.href)).pathname.indexOf("login") === -1) {
        // yield put({ type: `LOGOUT`, payload: error.response });
        sessionStorage.clear();
        window.location.href = "/login";
      }
      // return;
    }

    if (error && error.status === 401 && !isWhitelabeled) {
      // yield put({ type: `LOGOUT`, payload: error.response });
      if ((new URL(window.location.href)).pathname.indexOf("login") === -1) {
        sessionStorage.clear();
        window.location.href = "/";
      }
      // return;
    }

    if (((error && error.message == "Network Error")  || (error.response && error.response.status === 401)) && isWhitelabeled) {
      //homeRedirectTenantWise(sessionStorage.getItem('tenant'), false)
    }

    yield* dispatchFulfilled(action, { status: 200, data: {} });

    if ((error && error.status === 502)) {
      // yield put({ type: `LOGOUT`, payload: error.response });
      localStorage.setItem("redirectTo", currentHref);

      setTimeout(() => {
        window.location.href = '/internal-server-error';
      }, 500)
      // return;
    }

    // if (error.request && error.request.readyState === 4) {
    //   localStorage.setItem("redirectTo", currentHref);

    //   setTimeout(() => {
    //     window.location.href = '/internal-server-error';
    //   }, 500)
    // }

    if (reject) {
      //localStorage.setItem("redirectTo",currentHref);
      //yield call(forwardTo, '/internal-server-error');
      reject(error, error.response ? error.response.status : error);
    }
  } finally {
    // yield put(setStopLoader());
  }
}

function forwardTo(location) {
  history.push(location);
}

function* dispatchFulfilled(action, response) {
  yield put({ type: `${action.payload.action}_SUCCESS`, payload: response });
}

function* dispatchRejected(actionType, action, error) {
  yield put({
    type: `${actionType}_ERROR`,
    actualAction: action,
    payload: { response: error },
  });
}

function* apiSaga() {
  const actionQueue = yield actionChannel("API_INVOCATION");
  while (true) {
    const action = yield take(actionQueue);
    yield fork(invokeAPI, action);
  }
}

export { invokeAPI };
export default apiSaga;
